import React from "react";
import { DesktopPopupModal, PickerType } from "halifax";
import { Button } from "@material-ui/core";

import { MonthAndDatePicker, MonthAndDatePickerType } from "../../../index";
import * as textConstants from "./textConstants";
import "./styles.scss";
import clsx from "clsx";
import { TripCategory } from "redmond";
import { ConnectedDesktopCalendarPickerProps } from "./container";
import { ISetDepartureDate, ISetReturnDate } from "../../../../actions/actions";

export interface IDesktopCalendarPickerProps
  extends ConnectedDesktopCalendarPickerProps {
  open: boolean;
  closePopup: () => void;
  tripCategory?: TripCategory;
  departureProp?: Date | null;
  returnProp?: Date | null;
  onClickDone?: () => void;
  saveDatesOnClose?: boolean;
  setReturnDate: (date: Date | null) => ISetReturnDate | void;
  setDepartureDate: (date: Date | null) => ISetDepartureDate | void;
}

export const DesktopCalendarPicker = (props: IDesktopCalendarPickerProps) => {
  const {
    open,
    closePopup,
    departureDate,
    returnDate,
    setDepartureDate,
    setReturnDate,
    departureProp,
    returnProp,
    tripCategory,
    onClickDone,
    saveDatesOnClose,
    setOpenDatesModal,
  } = props;

  const headerTitle =
    tripCategory === TripCategory.ONE_WAY
      ? textConstants.DESKTOP_CALENDAR_TITLE_ONE_WAY
      : textConstants.DESKTOP_CALENDAR_TITLE_ROUND_TRIP;

  const [dep, setDep] = React.useState<Date | null>(null);
  const [ret, setRet] = React.useState<Date | null>(null);

  React.useEffect(() => {
    setDep(departureDate);
  }, [departureDate]);

  React.useEffect(() => {
    setRet(returnDate);
  }, [returnDate]);

  React.useEffect(() => {
    departureProp && setDep(departureProp);
  }, [departureProp]);

  React.useEffect(() => {
    returnProp && setRet(returnProp);
  }, [returnProp]);

  const handleClickDone = () => {
    closePopup();
    setOpenDatesModal(false);
    setDepartureDate(dep);
    setReturnDate(ret);
    onClickDone && onClickDone();
  };

  const handleClose = () => {
    closePopup();
    setOpenDatesModal(false);
    if (!saveDatesOnClose) {
      setDep(departureDate);
      setRet(returnDate);
    }
  };

  return (
    <DesktopPopupModal
      open={open}
      onClose={handleClose}
      className={clsx(
        "desktop-calendar-picker-popup-root",
        "desktop-flight-calendar-picker-popup-root",
        "flights-module"
      )}
      contentClassName="desktop-calendar-picker-wrapper"
      invisibleBackdrop={false}
    >
      <MonthAndDatePicker
        pickerType={
          tripCategory === TripCategory.ROUND_TRIP
            ? PickerType.RANGE
            : PickerType.DAY
        }
        viewType={MonthAndDatePickerType.Horizontal}
        startDate={dep}
        endDate={ret}
        setStartDate={(val: Date | null) => {
          setDep(val);
        }}
        setEndDate={(val: Date | null) => {
          setRet(val);
        }}
        header={headerTitle}
        className="b2b-flights"
      />
      <Button
        onClick={handleClickDone}
        disabled={
          (tripCategory === TripCategory.ROUND_TRIP && (!ret || !dep)) ||
          (tripCategory === TripCategory.ONE_WAY && !dep)
        }
        className="select-dates-button"
        variant="contained"
      >
        {textConstants.DONE_BUTTON_TEXT}
      </Button>
    </DesktopPopupModal>
  );
};
